import React from "react";
import {
  FaCheckCircle,
  FaShippingFast,
  FaCogs,
  FaUserCog,
} from "react-icons/fa";

export default function WhyChooseKSU() {
  return (
    <section className="bg-white text-center mt-[5%] md:mt-[3%] px-4 md:px-6 py-16 pb-3">
      {/* Top Section */}
      <div className="max-w-4xl mx-auto mb-10">
        <h2 className="text-4xl text-shadow font-bold mb-4 ">Why choose KSU</h2>
        <p className="text-gray-600 font-medium">
          KSU offers a diverse selection of high-quality hinges and hardware
          solutions. Our products are designed for durability and precision,
          catering to both B2B and individual needs.
        </p>
      </div>

      {/* Features & Image */}
      <div className="flex flex-col lg:flex-row items-center justify-center gap-10 mb-12">
        {/* Left Features */}
        <div className="flex flex-col items-center lg:items-end gap-10 w-full lg:w-1/3">
          <div className="max-w-sm text-center">
            <div className="flex justify-center mb-2">
              <FaCheckCircle className="text-black text-3xl" />
            </div>
            <h4 className="text-3xl font-semibold">ISO 9001:2015 Certified</h4>
            <p className="text-gray-600 text-base md:text-lg mt-1">
              Rigorous quality management systems ensure consistent excellence
              in every product we manufacture.
            </p>
          </div>
          <div className="max-w-sm text-center">
            <div className="flex justify-center mb-2">
              <FaShippingFast className="text-black text-3xl" />
            </div>
            <h4 className="text-3xl font-semibold">Rapid Delivery</h4>
            <p className="text-gray-600 text-base md:text-lg mt-1">
              Streamlined production processes and global logistics ensure fast
              turnaround times for urgent projects.
            </p>
          </div>
        </div>

        {/* Center Image */}
        <div className="w-full lg:w-[280px]  flex justify-center">
          <img
            src="why.svg"
            alt="KSU Hinge"
            className="rounded-md w-full max-w-xs"
          />
        </div>

        {/* Right Features */}
        <div className="flex flex-col items-center lg:items-start gap-10 w-full lg:w-1/3">
          <div className="max-w-sm text-center">
            <div className="flex justify-center mb-2">
              <FaCogs className="text-black text-3xl" />
            </div>
            <h4 className="text-3xl font-semibold">Precision Engineering</h4>
            <p className="text-gray-600 text-base md:text-lg mt-1">
              Advanced CNC machining and quality control processes deliver
              tolerances within ±0.1mm specifications.
            </p>
          </div>
          <div className="max-w-sm lg:ms-24 text-center">
            <div className="flex justify-center mb-2">
              <FaUserCog className="text-black text-3xl" />
            </div>
            <h4 className="text-3xl  font-semibold">Custom Solutions</h4>
            <p className="text-gray-600 text-base md:text-lg mt-1">
              Tailored to your needs
            </p>
          </div>
        </div>
      </div>

      {/* Learn More Button */}
      <a
        href="https://www.instagram.com/ksu.hinge?igsh=d3F1MzJlZXJnZXc2"
        target="_blank"
      >
        <button className="px-6 py-2 border border-black rounded-md font-medium hover:bg-black  hover:text-white transition-all duration-300 mb-10">
          Learn More
        </button>
      </a>

      {/* CTA Footer */}
      <div className=" bg-[#02347B] text-white px-6 py-10 rounded-lg text-center">
        <h3 className="text-lg font-semibold mb-2">
          Need Custom Specifications?
        </h3>
        <p className="text-sm mb-6">
          Our engineering team can design hinges to meet your exact requirements
        </p>
        <div className="flex flex-col md:flex-row justify-center gap-4">
          <button
            onClick={() => window.open("https://wa.link/ji1hnl", "_blank")}
            className="bg-white text-blue-600  px-6 py-2 rounded-md font-semibold hover:bg-gray-300 transition-all duration-300"
          >
            Request Quote
          </button>
          <button
            className="border border-white px-6 py-2 rounded-md font-semibold hover:bg-blue-500 transition-all duration-300"
            onClick={() => {
              const link = document.createElement("a");
              link.href = "catelog_2_merged.pdf";
              link.download = "catalog.pdf";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            Download catalogue
          </button>
        </div>
      </div>
    </section>
  );
}
